import { Pipe, PipeTransform } from '@angular/core';
import { MissionType } from '../../../core/models/freight-document/Mission';

@Pipe({
  name: 'missionType',
})
export class MissionTypePipe implements PipeTransform {
  private key = 'missionType';
  private missionTypeMap = new Map([
    [MissionType.COLLECTION, `${this.key}.collection`],
    [MissionType.DELIVERY, `${this.key}.delivery`],
  ]);

  transform(missionType: MissionType | undefined): string {
    if (missionType && this.missionTypeMap.has(missionType)) {
      return this.missionTypeMap.get(missionType) as string;
    }

    return '';
  }
}
